import {
  archiveUserProfiles,
  performInhabitantsMassAction,
  reinviteUserProfiles,
  restoreUserProfiles,
} from '../../../../../api'
import {
  HTTP_STATUS_BAD_REQUEST,
  HTTP_STATUS_OK,
} from '../../../../../constants/api'
import { EMPTY_LIST } from '../../../../../constants/common'
import {
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_NOT_CONFIRMED,
} from '../../../../../constants/user'
import { USER_PROFILE_PAGE_HEADER_FOOTER_ACTION } from '../../UserProfilePageHeaderFooter.constants'

import { USER_PROFILE_PAGE_PERFORM_ACTION_API_NAME } from './useUserProfilePagePerformAction.constants'

function getMassActionItems({ data }) {
  return { items: data }
}

function getReinviteMassActionItems({
  data: { fail = EMPTY_LIST, skip = EMPTY_LIST, success = EMPTY_LIST },
}) {
  return {
    items: [
      ...success.map(id => ({ id, status_code: HTTP_STATUS_OK })),
      ...[...fail, ...skip].map(id => ({
        id,
        status_code: HTTP_STATUS_BAD_REQUEST,
      })),
    ],
  }
}

export function getUserProfilePagePerformActionNotificationTitle({
  action,
  t,
}) {
  const titles = {
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]: t(
      'Notification.InhabitantTitleApprovedKey'
    ),
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive]: t(
      'Notification.CommonTitleArchivedKey'
    ),
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore]: t(
      'Notification.CommonTitleRestoredKey'
    ),
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite]: t(
      'Notification.InhabitantTitleSentInviteKey'
    ),
  }

  return titles[action] || null
}

export function getUserProfilePageStatusUpdateNotificationTitleKey(status) {
  return status === USER_STATUS_CODE_BLOCKED
    ? 'Notification.CommonTitleBlockedKey'
    : 'Notification.CommonTitleUnblockedKey'
}

export function getUserProfilePagePerformActionStatusFilter(action) {
  const statusFilters = {
    [USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.approveRegistration]: [
      USER_STATUS_CODE_NOT_CONFIRMED,
    ],
  }

  return statusFilters[action]
}

export function performInhabitantUserProfileMassAction({
  action,
  id,
  isArchived,
  payload,
}) {
  return performInhabitantsMassAction({
    data: {
      action: USER_PROFILE_PAGE_PERFORM_ACTION_API_NAME[action],
      all: false,
      filters: {
        archived: isArchived,
        id: [id],
        status: getUserProfilePagePerformActionStatusFilter(action),
      },
      payload,
    },
  }).then(({ data }) => data)
}

// TODO: drop this and route staff through performInhabitantUserProfileMassAction
// once `inhabitants/mass-action/` stops filtering admins and managers out.
export function performStaffUserProfileMassAction({
  action,
  id,
  isArchived,
  payload,
}) {
  switch (action) {
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.archive:
      return archiveUserProfiles({ ids: [id] }).then(getMassActionItems)
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.restore:
      return restoreUserProfiles({ ids: [id] }).then(getMassActionItems)
    case USER_PROFILE_PAGE_HEADER_FOOTER_ACTION.sendInvite:
      return reinviteUserProfiles({ data: payload, ids: [id] }).then(
        getReinviteMassActionItems
      )
    default:
      return performInhabitantUserProfileMassAction({
        action,
        id,
        isArchived,
        payload,
      })
  }
}
